import Repository from '../../repositories/RepositoryFactory';
import MedicalNoteCategoryRepository from '@/data/repositories/v1/MedicalNoteCategoryRepository';
Repository.get('medicalnotecategory');
export default {
    namespaced: true,
    state: {
        medicalNotesCategories: [],
        medicalNotesCategoriesForHospital: [],
        aditionalNoteId: null,
    },
    mutations: {
        GET_MEDICAL_NOTES_CATEGORY (state, payload) {
            state.medicalNotesCategories = payload;
        },
        GET_MEDICAL_NOTES_CATEGORY_FOR_HOSPITAL (state, payload) {
            state.medicalNotesCategoriesForHospital = payload;
        },
        SET_ADITIONAL_NOTE_ID (state, payload) {
            state.aditionalNoteId = payload;
        },
    },
    actions: {
        async medicalnotecategorytemplate ({ commit }, object) {
            commit('GET_MEDICAL_NOTES_CATEGORY', await MedicalNoteCategoryRepository.medicalnotecategorytemplate(object));
        },
        async medicalnotecategorytemplateforhospital ({ commit }, object) {
            const response = await MedicalNoteCategoryRepository.medicalnotecategorytemplateforhospital(object);
            commit('GET_MEDICAL_NOTES_CATEGORY_FOR_HOSPITAL', response);
            return response;
        },
        async addmedicalnotecategorytemplate ({ commit }, object) {
            return MedicalNoteCategoryRepository.addmedicalnotecategorytemplate(object);
        },
        async editmedicalnotecategorytemplate ({ commit }, object) {
            return MedicalNoteCategoryRepository.editmedicalnotecategorytemplate(object);
        },
        async deletemedicalnotecategorytemplate ({ commit }, object) {
            return MedicalNoteCategoryRepository.deletemedicalnotecategorytemplate(object);
        },
        async medicalnotecategorytemplatechangestatus ({ commit }, object) {
            return MedicalNoteCategoryRepository.medicalnotecategorytemplatechangestatus(object);
        },
        async copyMedicalNoteCategoryTemplateFromLocationIdToLocationid ({ commit }, object) {
            return MedicalNoteCategoryRepository.copyMedicalNoteCategoryTemplateFromLocationIdToLocationid(object);
        },

    },
    getters: {},
};
